import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class FinancialTariffAuction extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/tariff/auction`)
  }

  statistics(courierId, filter, showProgress) {
    return this._request({
      action: `statistics/${courierId}`,
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
